/**
 * Checks if element has a horizontal scrollbar.
 *
 * @param {HTMLElement} element to check overflow-x on.
 *
 * @return {boolean} returns true or false
 */
function hasOverflowX( element ) {
	return element.scrollWidth > element.clientWidth;
}

/**
 * Debounces to every 100ms, so window.resize does not constantly fire.
 *
 * @param {Function} func to run on debounce
 * @param {number}   time time in ms to debounce, default 100
 *
 * @return {boolean} returns true or false
 */
function debounce( func, time = 100 ) {
	let timer;
	return function( event ) {
		if ( timer ) {
			clearTimeout( timer );
		}
		timer = setTimeout( func, time, event );
	};
}

/**
 * If submenus have overflow-x, set justify-content to flex-start so all content is visible.
 *
 * @return {void}
 */
function applySubmenuClass() {
	const megamenuSubmenus = document.querySelectorAll( '.nav-menu-desktop > .megamenu > .sub-menu-container > .sub-menu-depth-0' );
	if ( megamenuSubmenus ) {
		megamenuSubmenus.forEach( submenu => {
			if ( hasOverflowX( submenu ) ) {
				submenu.classList.add( 'sub-menu--left' );
			} else {
				submenu.classList.remove( 'sub-menu--left' );
			}
		} );
	}
}

// applySubmenuClass on pageload
applySubmenuClass();

// also on windowResize (with debouncer so we don't make the page slow)
// e.g. if iPad Pro rotated from portrait to landscape and menu now wants to be centered
window.addEventListener( 'resize', debounce( applySubmenuClass ) );
